import { defaultAxios, IParams } from '../base';

export interface IFetchSelectLDongList extends IParams {
  // todo parameter 추가 예정
}

// 주담대 법정동 조회
export const fetchSelectLDongList = async (params: IFetchSelectLDongList) => {
  return await defaultAxios().post(`/base/selectLDongList`, params);
};
